<template>
  <div v-if="adminGhostUser && authenticated">
    <transition name="bottom-sheet-transition">
      <div
        v-if="adminGhostUser"
        role="document"
        tabindex="0"
        class="v-dialog__content v-dialog__content--active customBottomSheetWrapper"
      >
        <div
          class="v-dialog v-dialog--active v-dialog--persistent v-bottom-sheet customBottomSheetWrapper-div"
        >
          <v-sheet class="text-center adminBottomSheet">
            <div class="py-0 text-h6 text-center" style="margin: 0 auto; width: 75%">
              <span class="text-uppercase">
                <v-icon dark>warning</v-icon>
                <span class="px-2"> admin ghost user </span>
                <v-icon dark>warning</v-icon>
              </span>
              <v-btn class="ml-6 mt-4 mb-4" :dark="$vuetify.theme.dark" @click="logout">
                logout
              </v-btn>
            </div>
          </v-sheet>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'GhostUserAlert',
  props: {
    authenticated: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },

  computed: {
    adminGhostUser() {
      const isGhostUser = localStorage.getItem('ghostToken');
      return !!isGhostUser;
    },
  },

  methods: {
    logout() {
      this.$emit('logout');
    },
  },
};
</script>

<style scoped>
.customBottomSheetWrapper {
  top: auto;
  height: auto;
  bottom: 0;
  z-index: 3;
}

.customBottomSheetWrapper-div {
  transform-origin: center center;
}

.adminBottomSheet {
  color: white !important;
  background-color: rgba(0, 0, 0, 0.85) !important;
}
</style>
